import { useEffect, useState } from 'react'
import { TemplateDetailEntity } from 'orders/domain/entities/templateDetail.entity'
import { TemplateDetailHttpRepository } from 'orders/infrastructure/repositories/TemplateDetailHttpRepository'
import { GetTemplateDetailUseCase } from 'orders/usecases/GetTemplateDetailUseCase'

interface UseTemplateDetailResult {
    template: TemplateDetailEntity | null
    loading: boolean
    error: string | null
}

export function useTemplateDetail(templateId: number | null): UseTemplateDetailResult {
    const [template, setTemplate] = useState<TemplateDetailEntity | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        if (!templateId) return
        let cancelled = false

        const useCase = new GetTemplateDetailUseCase(new TemplateDetailHttpRepository())

        const fetch = async () => {
            setLoading(true)
            setError(null)
            try {
                const data = await useCase.execute(templateId)
                if (!cancelled) setTemplate(data)
            } catch {
                if (!cancelled) setError('No se pudo cargar el detalle de la plantilla.')
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        fetch()
        return () => { cancelled = true }
    }, [templateId])

    return { template, loading, error }
}
